(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('BundleSearch', BundleSearch);

    BundleSearch.$inject = ['$resource'];

    function BundleSearch($resource) {
        var resourceUrl =  'api/_search/bundles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
